import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import { DatabaseService } from "../providers/database.service";

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.css']
})
export class VideoComponent implements OnInit {

  @Input() streamInfo;
  mediatorList: any[] = [];

  constructor(private sanitizer: DomSanitizer, public db: DatabaseService) { 
    var ref = db.getMediators();
    ref.on('value',
      snap => {
        var medsObject = snap.val();
        this.mediatorList = Object.keys(medsObject).map(
          key => {
            return medsObject[key];
          }
        )
      });
  }

  ngOnInit() {
  }

  endPlay() {
    var vid: any = document.getElementById('previewStream');
    vid.src = '';
  }

  getYouTubeUrl() {
    let sanUrl = this.streamInfo.url + "?rel=0&amp;controls=0&amp;showinfo=0&amp;autoplay=1";
    // console.log(sanUrl);
    return this.sanitizer.bypassSecurityTrustResourceUrl(sanUrl);
  }

  getStreamSchema() {
    var url: string = '';
    for (let med of this.mediatorList) {
      console.log('comparing: ' + med.name + " - " + this.streamInfo.mediatorName);
      if (med.name === this.streamInfo.mediatorName) {
        url = med.schemaFile;
      }
    }
    return url;
  }

  startVideo() {
    // console.log(this.streamInfo);
    var vidWin = document.getElementById('videoFrame');
    vidWin.innerHTML = this.streamInfo.u   
  }

}



// WEBPACK FOOTER //
// /var/www/html/mediate/src/app/video/video.component.ts